var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMounted)?_c('div',{staticClass:"documentation flex items-start w-full"},[(_vm.newVersion)?_c('div',{staticClass:"w-full"},[_c('NavBar',{attrs:{"nav-items":_vm.nav}}),_c('router-view',{attrs:{"jsonData":_vm.json}})],1):_c('div',{staticClass:"w-full"},[_c('div',{ref:"test",staticClass:"swaggers",attrs:{"id":"swagger"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }